<div class="local-db vertical-center">
  <div class="db-item">
    <span class="bot-name-ellipsis">
      {{localInstance ? localInstance.externalServer.name : ''}}-{{formatName(bot.botServiceId)}}
    </span>
  </div>
</div>
<div class="local-bots mr-2">
  <span
    (click)="navigateBot()"
    tooltip="{{bot.name}}"
    placement="top"
    class="badge mr-2 cursor-pointer">
    {{bot.name}}
  </span>
</div>
<div
*ngIf="externalInstances && externalInstances.length && instanceLocations && instanceLocations.length"
  class="target-db d-flex flex-column align-items-center">

  <div class="position-relative" *ngFor="let instance of externalInstances; let i = index">
    <i *ngIf="instanceLocations[i].externalServiceId"
      class="fad fa-circle db-checker text-{{checkDBType(instanceLocations[i].externalServiceId) ? 'success' : 'danger'}}"
      tooltip="{{(checkDBType(instanceLocations[i].externalServiceId) ? 'All good!' : 'DB type mismatch') | translate}}" placement="left"></i>
    <i *ngIf="!instanceLocations[i].externalServiceId"
      class="fad fa-circle-dot db-checker text-muted"
      tooltip="{{'No remote database selected' | translate}}" placement="left"></i>
    <!--
    <select
      *ngIf="instanceLocations[i] && instance.externalServer.id === selectedInstance"
      [(ngModel)]="instanceLocations[i].externalServiceId"
      (change)="onLocationChange()"
      class="form-control">
      <ng-container *ngIf="(instance.services | filterBy: servicesFilter).length">
        <option
          *ngFor="let service of instance.services | filterBy: servicesFilter"
          value="{{service.id}}">
          {{service.name}}   
      </ng-container>
      <ng-container *ngIf="(instance.services | filterBy: servicesFilter).length === 0">
        <option
          *ngFor="let service of instance.services" 
          value="{{service.id}}">
          {{service.name}}
        </option>
      </ng-container>
    </select>
    -->
    <search-services *ngIf="instanceLocations[i] && instance.externalServer.id === selectedInstance"
      class="w-100"
      (changeValue)="onLocationChange($event, instanceLocations[i])"
      [items]="instance.services"
      [selected]="instanceLocations[i].externalServiceId"
      [formatGDB]="true"
      [placeholder]="'Select remote database' | translate">
    </search-services>
  </div>
</div>
